import type { Uid } from '../../cross-app-shared/types/common.ts';
import type { User } from '../types/common.ts';

export function usersArrayToMap(users: User[]): Map<Uid, User> {
  const userMap = new Map<Uid, User>();
  for (const user of users) {
    userMap.set(user.uid, user);
  }
  return userMap;
}

export function uidsToUsers(users: Map<Uid, User>, uids: Uid[]): User[] {
  return uids.flatMap((uid) => {
    const user = users.get(uid);
    if (user) {
      return [user];
    } else {
      return [];
    }
  });
}

export function getUserDisplayName(user: User): string {
  return user.name || user.email || 'Unknown User';
}
